import { render } from "./OnlineTestInstructions.vue?vue&type=template&id=0ac20bca"
import script from "./OnlineTestInstructions.vue?vue&type=script&lang=js"
export * from "./OnlineTestInstructions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__